export const ERROR_BOUNDARY_PREFIX_CAPYBARA = 'Capybara';
export const ERROR_BOUNDARY_PREFIX_PACKAGES = 'Packages';
